import {Component} from '@angular/core';
import {CartService} from '../../services/cart/cart.service';

@Component({
  selector: 'app-cart-timer',
  templateUrl: './cart-timer.component.html',
  styleUrls: ['./cart-timer.component.scss']
})
export class CartTimerComponent {
  constructor(private cartService: CartService) {}

  public get isTimerDefined(): boolean {
    return this.cartService?.timeRemaining != null;
  }
  public get hours(): number {
    return Math.floor(((this.cartService.timeRemaining || 0) % (3600 * 24)) / 3600);
  }
  public get minutes(): number {
    return Math.floor(((this.cartService.timeRemaining || 0) % 3600) / 60);
  }
  public get seconds(): number {
    return Math.floor((this.cartService.timeRemaining || 0) % 60);
  }
}
